import {Injectable} from '@angular/core';
import {API_BASE_URL} from './env.service';
import {BehaviorSubject} from 'rxjs';
import {CurrentWeather} from '../../shared/models/weather';
import {HttpClient} from '@angular/common/http';

const WEATHER_FETCH_INTERVAL_MS = 120000;

@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  currentWeather$: BehaviorSubject<CurrentWeather>;

  private postalCode: string = '';
  private recurringInterval: number = 0;


  constructor(
    private http: HttpClient,
  ) {
    this.currentWeather$ = new BehaviorSubject<CurrentWeather>({
      AirQuality: {CO: 0, PM25: 0, USEPAIndex: 0},
      Cloud: 0,
      Condition: {Code: undefined, Text: ''},
      Humidity: null,
      IsDay: false,
      LastUpdatedUnix: 0,
      Location: {City: '', State: '', TimeZone: ''},
      TemperatureC: null,
      TemperatureF: null,
      Wind: {Degree: 0, Direction: '', MPH: ''},
    });
  }


  updateCurrentWeather(postalCode?: string): void {
    if (postalCode) {
      this.postalCode = postalCode;
    }

    this.setUpInterval();
    this.fetch();
  }


  private setUpInterval() {
    if (this.recurringInterval) {
      clearInterval(this.recurringInterval);
    }

    this.recurringInterval = window.setInterval(() => this.fetch(), WEATHER_FETCH_INTERVAL_MS);
  }


  private fetch() {
    if (!this.postalCode) {
      return;
    }

    this.http.get<CurrentWeather>(`${API_BASE_URL}/weather/postal-code/${this.postalCode}`).subscribe(
      (weather) => {
        this.currentWeather$.next(weather);
      },
    );
  }
}
